import React from "react";
import {
    Heading,
    ListItem,
    List,
    Text
} from "spectacle";
import Button from '../components/Button';

const OurSolutionWhenWhatHow = () =>
    <div>
        <Heading size={6} textColor="secondary" caps>
            WHEN, HOW, WHAT
            </Heading>
        <Text textSize={30} textColor="primary">
            SINTEL.AI will be launched during Disrupt SF, 2018 – v1 - immediate availability.
        </Text>

        <List ordered textColor="secondary" style={{ paddingLeft: '25px', listStylePosition: 'outside' }}>
            <ListItem textSize={25}>$5 usd per user per month.</ListItem>
            <ListItem textSize={25}>free trial for Disrupt attendees</ListItem>
        </List>
    </div>

export default OurSolutionWhenWhatHow;


// WEBPACK FOOTER //
// ./src/slides/OurSolutionWhenWhatHow.js